import authAxios from '@/auth/auth-axios';

export default class AffiliateService {
  static async find() {
    const axios = await authAxios();
    const response = await axios.get(`/affiliate`);
    return response.data;
  }

  static async listCommissions() {
    const axios = await authAxios();
    const response = await axios.get(
      `/affiliate/commission`,
    );
    return response.data;
  }

  static async findBalance() {
    const axios = await authAxios();
    const response = await axios.get(
      `/affiliate/commission/balance`,
    );
    return response.data;
  }

  static async updateNotify(active) {
    const axios = await authAxios();

    const response = await axios.put(
      `/affiliate/commission/notify`,
      {
        notify: !!active,
      },
    );

    return response.data;
  }
}
